module.exports = __webpack_public_path__ + "img/repeat.3e9d6b18.svg";